import {
  ActionCard,
  Card,
  Divider,
  Stack,
  Text,
  VStack,
} from '@adc/parallax-component-library';
import { IconAlarmsUnavailable } from '@adc/parallax-icons/icons/alarms-unavailable';
import { IconInfo } from '@adc/parallax-icons/icons/info';

import { buildTestId } from '~/utils/buildTestId';

type AlertPreviewProps = {
  testID: string;
  phone: string;
};

export const AlertPreview = ({ testID, phone }: AlertPreviewProps) => (
  <Stack maxWidth={364}>
    <Card
      testID={testID}
      title="Preview"
      auxiliaryIcon={{ element: <IconInfo color="$color.gray11Light" /> }}
      titleAriaLevel={1}
      // @ts-expect-error TODO replace for the correct prop whenever changing the card color (backgroundColor) is a supported prop by Parallax.
      backgroundColor="$gray3Light"
    >
      <Divider />
      <VStack flex={1} marginVertical="$3" paddingHorizontal="$5">
        <ActionCard
          testID={buildTestId({ testID, suffix: ['alert', 'preview', 'card'] })}
          header={{
            label: 'Lactate Alert',
            // TODO: Add the proper color, right now icon color change does not work properly.
            iconStart: (
              <IconAlarmsUnavailable
                style={{
                  // @ts-expect-error There is no other way to specify red color for this icon
                  color: '#E4002B',
                }}
              />
            ),
          }}
          primaryAction={{
            testID: buildTestId({
              testID,
              suffix: ['alert', 'preview', 'acknowledge', 'button'],
            }),
            label: 'Acknowledge',
            onPress: () => {
              // TODO: Not Implemented
            },
          }}
        >
          <Stack gap="$2" paddingHorizontal="$5" paddingVertical="$3">
            <Text alignStart>
              Your lactate level is high. Contact your care team as soon as
              possible.
            </Text>
            <Text alignStart>
              Call{' '}
              <Text
                // TODO: Replace it with the correct color token.
                color="$blue11Light"
              >
                {phone}
              </Text>
            </Text>
            <Text alignStart>
              If you are having a medical emergency, call emergency services.
            </Text>
          </Stack>
        </ActionCard>
      </VStack>
    </Card>
  </Stack>
);
